import { smartTeamsNoteTag } from './_note-origin.js';

/**
 * The `ticket_event` payload for an FE's free-text comment: an internal work note on the work order task
 * (`add_worknote`, mapped to `wm_task.work_notes`). Kept pure so the wording can be tested without
 * ServiceNow.
 *
 * The note always starts with the `[From Smartteams - <engineer>]` tag (see _note-origin.ts), so a note from
 * SmartTeams can be told apart from one ServiceNow or a dispatcher wrote. A work note has no priority field, so
 * "Emergency" is carried as a prefix in the text, after the tag.
 */
export const EMERGENCY_PREFIX = '[EMERGENCY] ';

export function buildCommentPayload(
  comment: string,
  emergency: boolean | null | undefined,
  engineerName: string | null | undefined,
): { worknote: string } {
  const text = comment.trim();
  if (!text) throw new Error('A comment is required');
  return { worknote: `${smartTeamsNoteTag(engineerName)} ${emergency ? EMERGENCY_PREFIX : ''}${text}` };
}
